import { create } from "zustand";
import type { ApiMessage } from "@/types";

interface UnreadInfo {
  last_message: ApiMessage;
  unread_count: number;
  last_message_at: string;
}

interface MessagingStore {
  activeConversationId: number | null;
  unreadTracker: Record<number, UnreadInfo>;
  setActiveConversationId: (id: number | null) => void;
  incrementUnread: (conversationId: number, message: ApiMessage) => void;
  clearUnread: (conversationId: number) => void;
}

export const useMessagingStore = create<MessagingStore>((set) => ({
  activeConversationId: null,
  unreadTracker: {},
  setActiveConversationId: (id) => set({ activeConversationId: id }),
  incrementUnread: (conversationId, message) =>
    set((state) => {
      // If this conversation is currently active, do not increment unread count
      if (state.activeConversationId === conversationId) {
        return {
          unreadTracker: {
            ...state.unreadTracker,
            [conversationId]: {
              last_message: message,
              unread_count: 0,
              last_message_at: message.created_at,
            },
          },
        };
      }
      const current = state.unreadTracker[conversationId];
      const count = current ? current.unread_count + 1 : 1;
      return {
        unreadTracker: {
          ...state.unreadTracker,
          [conversationId]: {
            last_message: message,
            unread_count: count,
            last_message_at: message.created_at,
          },
        },
      };
    }),
  clearUnread: (conversationId) =>
    set((state) => {
      const current = state.unreadTracker[conversationId];
      if (!current) return state;
      return {
        unreadTracker: {
          ...state.unreadTracker,
          [conversationId]: {
            ...current,
            unread_count: 0,
          },
        },
      };
    }),
}));
